module.exports = __webpack_public_path__ + "static/media/tablet1.307ac310.png";